<template>
  <section>
    <el-form class="form-grid channel-form-grid" label-position="top" @submit.prevent>
      <el-form-item label="名称">
        <el-input v-model.trim="form.name" placeholder="DeepSeek" />
      </el-form-item>
      <el-form-item label="官网">
        <el-input v-model.trim="form.official_url" placeholder="https://www.deepseek.com" />
      </el-form-item>
      <el-form-item label="Base URL">
        <el-input v-model.trim="form.base_url" placeholder="https://api.openai.com" />
      </el-form-item>
      <el-form-item label="上游 API Key">
        <el-input v-model.trim="form.api_key" show-password />
      </el-form-item>
      <el-form-item label="鉴权方式">
        <el-select v-model="form.auth_type">
          <el-option label="bearer" value="bearer" />
          <el-option label="x-api-key" value="x-api-key" />
          <el-option label="anthropic" value="anthropic" />
        </el-select>
      </el-form-item>
      <el-form-item label="计费适配器">
        <el-select v-model="form.billing_adapter">
          <el-option label="OpenAI 兼容" value="openai" />
        </el-select>
      </el-form-item>
      <el-form-item label="权重">
        <el-input-number v-model="form.weight" :min="1" controls-position="right" />
      </el-form-item>
      <el-form-item label="备注" class="span-2">
        <el-input v-model.trim="form.remark" placeholder="渠道备注" />
      </el-form-item>
      <el-form-item label="模型列表" class="span-2">
        <el-input v-model="modelsText" type="textarea" :rows="3" placeholder="deepseek-chat&#10;gpt-4o-mini" />
      </el-form-item>
      <el-form-item label="模型映射 JSON" class="span-2">
        <el-input v-model="mappingText" type="textarea" :rows="3" placeholder='{"fast":"deepseek-chat"}' />
      </el-form-item>
      <el-form-item label="System Prompt" class="span-2">
        <el-input v-model.trim="form.system_prompt" type="textarea" :rows="3" placeholder="Default system prompt for this channel" />
      </el-form-item>
      <el-form-item class="span-2">
        <div class="switch-row">
          <el-switch v-model="form.system_prompt_override" />
          <span>Append channel system prompt before user system prompt</span>
        </div>
      </el-form-item>
      <el-form-item>
        <div class="switch-row">
          <el-switch v-model="enabled" />
          <span>启用渠道</span>
        </div>
      </el-form-item>
      <el-form-item>
        <div class="switch-row">
          <el-switch v-model="form.supports_vision" />
          <span>支持图片输入</span>
        </div>
      </el-form-item>
      <el-form-item class="form-actions">
        <el-button type="primary" :loading="loading" @click="submit">保存</el-button>
        <el-button @click="$emit('cancel')">取消</el-button>
      </el-form-item>
    </el-form>
    <el-alert v-if="notice" class="notice-alert" :title="notice" :type="noticeType" show-icon :closable="false" />
  </section>
</template>

<script>
const defaultForm = () => ({
  name: '',
  official_url: '',
  base_url: '',
  api_key: '',
  auth_type: 'bearer',
  billing_adapter: 'openai',
  remark: '',
  system_prompt: '',
  system_prompt_override: false,
  supports_vision: false,
  weight: 1
})

export default {
  name: 'ChannelForm',
  props: {
    editingChannel: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    notice: {
      type: String,
      default: ''
    },
    noticeType: {
      type: String,
      default: 'success'
    }
  },
  emits: ['submit', 'cancel'],
  data() {
    return {
      form: defaultForm(),
      modelsText: '',
      mappingText: '{}',
      enabled: true
    }
  },
  watch: {
    editingChannel: {
      immediate: true,
      handler(channel) {
        if (!channel) {
          this.form = defaultForm()
          this.modelsText = ''
          this.mappingText = '{}'
          this.enabled = true
          return
        }
        this.form = {
          name: channel.name,
          official_url: channel.official_url || '',
          base_url: channel.base_url,
          api_key: channel.api_key,
          auth_type: channel.auth_type || 'bearer',
          billing_adapter: channel.billing_adapter || 'openai',
          remark: channel.remark || '',
          system_prompt: channel.system_prompt || '',
          system_prompt_override: Boolean(channel.system_prompt_override),
          supports_vision: Boolean(channel.supports_vision),
          weight: channel.weight
        }
        this.modelsText = this.formatModels(channel.models)
        this.mappingText = this.formatMapping(channel.model_mapping)
        this.enabled = channel.status === 1
      }
    }
  },
  methods: {
    submit() {
      let mapping = {}
      try {
        mapping = JSON.parse(this.mappingText || '{}')
      } catch (error) {
        window.alert('模型映射必须是合法 JSON')
        return
      }
      this.$emit('submit', {
        ...this.form,
        models: this.modelsText.split(/\n|,/).map((item) => item.trim()).filter(Boolean),
        model_mapping: mapping,
        status: this.enabled ? 1 : 0
      })
    },
    formatModels(raw) {
      if (!raw) {
        return ''
      }
      try {
        const models = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Array.isArray(models) ? models.join('\n') : ''
      } catch (error) {
        return ''
      }
    },
    formatMapping(raw) {
      if (!raw) {
        return '{}'
      }
      try {
        const mapping = typeof raw === 'string' ? JSON.parse(raw) : raw
        return JSON.stringify(mapping || {}, null, 2)
      } catch (error) {
        return '{}'
      }
    }
  }
}
</script>
